import { render, staticRenderFns } from "./touch-sales-order.vue?vue&type=template&id=b4efbfd6&"
import script from "./touch-sales-order.vue?vue&type=script&lang=js&"
export * from "./touch-sales-order.vue?vue&type=script&lang=js&"
import style0 from "./touch-sales-order.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports